"use client";

import Button from "@/components/Button";
import { ArrowRightIcon } from "lucide-react";
import Link from "next/link";
import { Trans } from "react-i18next";
import AllSubscription from "../AllSubscription";
import PublicCreation from "../PublicCreation";
import LandingSection3 from "./LandingSection3";

export default function Microsite() {
  return (
    <>
      <div className="mx-auto mt-20 px-3 w-full max-w-[100rem]">
        <section
          id="hero"
          className="relative flex flex-col justify-center bg-indigo-50/50 mt-10 border border-indigo-200 rounded-3xl h-full overflow-hidden"
        >
          <div className="absolute inset-0 opacity-50 rounded-3xl overflow-hidden" />
          <div className="relative flex flex-col justify-center px-4 min-h-[30rem] lg:min-h-[40rem]">
            <h1 className="mx-auto max-w-3xl font-montserrat font-bold text-4xl lg:text-6xl text-center">
              <Trans i18nKey="landing:microsite_hero_title">
                Website Instan{" "}
                <span className="text-indigo-600">Microsite</span>, tanpa ribet
                harus Coding.
              </Trans>
            </h1>
            <p className="mx-auto mt-4 max-w-4xl font-worksans lg:text-2xl text-center">
              <Trans i18nKey="landing:microsite_hero_desc">
                Kini kamu bisa memiliki mini website secara cepat dan mudah,
                tanpa perlu keahlian coding apa pun. Semua bisa dilakukan
                langsung dengan <strong>Microsite</strong> dari s.id.
              </Trans>
            </p>
            <PublicCreation initial="microsite" single />
          </div>

          <img
            src="/images/microsite-001.png?001"
            className="mx-auto border border-b-0 rounded-t-3xl w-full max-w-6xl overflow-hidden"
          />
        </section>

        <section className="flex flex-wrap -mx-2 mt-6">
          <div className="p-2 w-full lg:w-6/12">
            <div className="relative flex flex-col border rounded-3xl h-full overflow-hidden">
              <div className="relative pb-[100%] lg:pb-[75%] overflow-hidden">
                <div
                  className="absolute inset-0 bg-contain bg-no-repeat bg-center scale-175 pointer-events-none"
                  style={{
                    backgroundImage: "url('/images/microsite-002.png')",
                  }}
                />
              </div>
              <div className="right-0 bottom-0 left-0 absolute bg-gradient-to-t from-white to-transparent p-6 pt-32">
                <h2 className="font-montserrat font-bold text-lg lg:text-3xl">
                  <Trans i18nKey="landing:microsite_component_title">
                    Beragam pilihan Komponen
                  </Trans>
                </h2>
                <div className="mt-1 max-w-md font-worksans text-muted-foreground lg:text-lg">
                  <Trans i18nKey="landing:microsite_component_desc">
                    Sesuaikan microsite kamu dengan komponen yang lengkap dan
                    mudah digunakan
                  </Trans>
                </div>
              </div>
            </div>
          </div>
          <div className="p-2 w-full lg:w-6/12">
            <div className="relative flex flex-col border rounded-3xl h-full overflow-hidden">
              <div className="relative pb-[100%] lg:pb-[75%]">
                <div
                  className="absolute inset-0 bg-contain bg-no-repeat bg-center pointer-events-none"
                  style={{
                    backgroundImage: "url('/images/microsite-003.png')",
                  }}
                />
              </div>
              <div className="right-0 bottom-0 left-0 absolute bg-gradient-to-t from-white to-transparent p-6 pt-32">
                <h2 className="font-montserrat font-bold text-lg lg:text-3xl">
                  <Trans i18nKey="landing:microsite_responsive_title">
                    Antarmuka Responsif
                  </Trans>
                </h2>
                <div className="mt-1 max-w-lg font-worksans text-muted-foreground lg:text-lg">
                  <Trans i18nKey="landing:microsite_responsive_desc">
                    Panel editor yang mudah digunakan di berbagai perangkat,
                    mulai dari ponsel, tablet, hingga desktop.
                  </Trans>
                </div>
              </div>
            </div>
          </div>

          <div className="p-2 w-full">
            <div className="flex md:flex-row flex-col items-center border rounded-3xl h-full overflow-hidden">
              <div className="relative lg:order-2 pb-[100%] lg:pb-[50%] w-full lg:w-6/12">
                <div
                  className="absolute inset-0 bg-contain bg-no-repeat bg-center pointer-events-none"
                  style={{
                    backgroundImage: "url('/images/microsite-004.png')",
                  }}
                />
              </div>
              <div className="flex-1 order-1 p-4 md:px-20 w-full lg:w-6/12">
                <h2 className="font-montserrat font-bold text-lg lg:text-5xl">
                  <Trans i18nKey="landing:microsite_theme_title">
                    Pilihan Tema yang beragam
                  </Trans>
                </h2>
                <div className="my-2 max-w-md font-worksans text-muted-foreground lg:text-2xl">
                  <Trans i18nKey="landing:microsite_theme_desc">
                    Sesuaikan tampilan microsite kamu dengan tema yang paling
                    cocok untuk gayamu
                  </Trans>
                </div>
              </div>
            </div>
          </div>

          <div className="p-2 w-full">
            <div className="flex lg:flex-row flex-col items-center bg-shop/10 border border-shop rounded-3xl h-full overflow-hidden">
              <div className="relative pb-[155%] sm:pb-[50%] w-full lg:w-6/12">
                <div className="absolute inset-0 flex flex-col justify-end items-center">
                  <img
                    src="/images/sid-shop-000.png"
                    className="z-10 relative w-full max-w-md"
                  />
                  <div className="right-0 bottom-0 left-0 z-10 absolute">
                    <div className="mx-auto -mb-20 w-full max-w-md -translate-y-12">
                      <img
                        src="/images/sid-shop-cursor.png"
                        className="right-0 bottom-0 z-20 absolute w-[15rem] -translate-y-[5rem] translate-x-[9rem]"
                        alt=""
                      />
                      <div className="flex w-full">
                        <div className="w-6/12">
                          <img
                            src="/images/sid-shop-001.png"
                            className="relative scale-[1.3] -translate-x-2 -translate-y-10"
                            alt=""
                          />
                        </div>
                        <div className="w-6/12">
                          <img
                            src="/images/sid-shop-002.png"
                            className="relative scale-[1.3] translate-x-2"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-1 p-4 md:px-20 w-full lg:w-6/12">
                <h2 className="font-montserrat font-bold text-lg lg:text-5xl">
                  <Trans i18nKey="landing:microsite_shop_title">
                    Jual Barang Digital
                  </Trans>
                </h2>
                <div className="my-2 max-w-md font-worksans text-muted-foreground lg:text-2xl">
                  <Trans i18nKey="landing:microsite_shop_desc">
                    Tawarkan konten digital langsung dari microsite kamu, tanpa
                    platform tambahan
                  </Trans>
                </div>
                <Link href="/shop">
                  <Button
                    roundFull
                    variant="ghost"
                    className="bg-shop hover:bg-shop/80 mt-2 px-5 h-auto font-worksans font-semibold text-white hover:text-white lg:text-xl"
                  >
                    <Trans i18nKey="landing:microsite_shop_button">
                      Kunjungi s.id Shop
                    </Trans>
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="mt-12 px-3">
          <h2 className="px-3 font-montserrat font-bold text-2xl lg:text-4xl text-center">
            <Trans i18nKey="landing:microsite_explore_title">
              Eksplor Microsite dari Pengguna s.id
            </Trans>
          </h2>
          <p className="mx-auto mt-2 max-w-4xl font-worksans lg:text-2xl text-center">
            <Trans i18nKey="landing:microsite_explore_desc">
              Temukan inspirasi dari pengguna lain untuk membuat microsite yang
              sesuai dengan kebutuhan bisnismu.
            </Trans>
          </p>

          <LandingSection3 />
        </section>

        <section id="subscription-section" className="mt-10 lg:mt-32">
          <h1 className="mx-auto max-w-6xl font-montserrat font-bold text-2xl lg:text-6xl text-center">
            <Trans i18nKey="landing:microsite_subscription_title">
              Maksimalkan campaign kamu dengan fitur s.id
            </Trans>
          </h1>
          <p className="mx-auto mt-4 max-w-4xl font-worksans lg:text-2xl text-center">
            <Trans i18nKey="landing:microsite_subscription_desc">
              Dapatkan lebih banyak fitur menarik hanya dengan satu langganan
            </Trans>
          </p>

          <AllSubscription noAction />

          <div className="flex justify-center mt-8 w-full">
            <Link href="/subscription">
              <Button
                className="flex items-center px-4 h-auto font-montserrat font-medium text-xl"
                roundFull
              >
                <Trans i18nKey="landing:see_more_detailed">
                  Lihat lebih lengkap
                </Trans>{" "}
                <ArrowRightIcon className="!size-6" />
              </Button>
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}
